import React from "react";

import { SvgIcon } from "@mui/material/";

const Login = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 96 960 960">
      <path d="M475.769 932v-58h246.924q9.23 0 16.922-7.693 7.693-7.692 7.693-16.922v-506.77q0-9.23-7.693-16.923Q731.923 318 722.693 318H475.769v-58h246.924q35.04 0 58.827 23.787 23.788 23.788 23.788 58.828v506.77q0 35.04-23.788 58.827Q757.733 932 722.693 932H475.769ZM426.23 745.539l-45.077-41.77L460.923 624H154.692v-58h306.231l-79.77-79.77 45.077-39.769L575.769 596 426.23 745.539Z" />
    </SvgIcon>
  );
};

export default Login;
